var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStudio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000049201132813807772390000001185004780734388621_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 865.2 601.2",
    style: {
      enableBackground: "new 0 0 865.2 601.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#808080;}\n\t.st1{fill:#00FF00;}\n\t.st2{fill:none;}\n\t.st3{fill:#B3B3B3;}\n\t.st4{fill:#666666;}\n\t.st5{fill:#FAE6B4;}\n\t.st6{fill:#9D718A;}\n\t.st7{fill:#415150;}\n\t.st8{fill:#2F3A3B;}\n\t.st9{fill:#4D5A5C;}\n\t.st10{fill:#8C9292;}\n\t.st11{fill:#465152;}\n\t.st12{fill:#2E383C;}\n\t.st13{fill:#161E20;}\n\t.st14{fill:#202B2D;}\n\t.st15{fill:#2A3738;}\n\t.st16{fill:#354242;}\n\t.st17{fill:#141E1D;}\n\t.st18{fill:#475253;}\n\t.st19{fill:#4D5859;}\n\t.st20{fill:#03070A;}\n\t.st21{fill:#566164;}\n\t.st22{opacity:0.4;fill:#00BDFF;enable-background:new    ;}\n\t.st23{opacity:0.7;fill:#FFFFFF;enable-background:new    ;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "First_Floor"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M713.6,315.7c0.1,0,0.2,0,0.2,0c1-0.1,1.7-1,1.5-2l-7.2-54.6c-0.1-1-1-1.7-2-1.5c-1,0.1-1.7,1-1.5,2 l7.2,54.6C711.9,315,712.7,315.7,713.6,315.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M730.5,278.8c0.6,0,1.1-0.3,1.4-0.7c0.6-0.8,0.4-1.9-0.4-2.5l-24.1-17.7c-0.8-0.6-1.9-0.4-2.5,0.4 s-0.4,1.9,0.4,2.5l24.1,17.7C729.8,278.7,730.1,278.8,730.5,278.8L730.5,278.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M667.3,288.9c0.4,0,0.7-0.1,1-0.3l39.8-28.4V106.8c0-1-0.8-1.8-1.8-1.8s-1.8,0.8-1.8,1.8v151.6l-38.3,27.3 c-0.8,0.6-1,1.7-0.4,2.5C666.2,288.7,666.7,288.9,667.3,288.9L667.3,288.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M712.5,272.9l-4.1,8.5l-10.9-6.2L712.5,272.9 M718.7,268.4l-31.9,4.9l23.1,13.2L718.7,268.4L718.7,268.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M534.2,212.9c0.1,0,0.2,0,0.2,0c1-0.1,1.7-1,1.5-2l-7.2-54.6c-0.1-1-1-1.7-2-1.5c-1,0.1-1.7,1-1.5,2 l7.2,54.6C532.6,212.2,533.3,212.9,534.2,212.9L534.2,212.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M551.1,176c0.6,0,1.1-0.3,1.4-0.7c0.6-0.8,0.4-1.9-0.4-2.5L528,155.1c-0.8-0.6-1.9-0.4-2.5,0.4 s-0.4,1.9,0.4,2.5l24.1,17.7C550.4,175.9,550.7,176,551.1,176L551.1,176z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M487.9,186.2c0.4,0,0.7-0.1,1-0.3l39.8-28.4V4.1c0-1-0.8-1.8-1.8-1.8s-1.8,0.8-1.8,1.8v151.6l-38.3,27.3 c-0.8,0.6-1,1.7-0.4,2.5C486.8,185.9,487.3,186.2,487.9,186.2L487.9,186.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M533.1,170.1l-4.1,8.5l-10.9-6.2L533.1,170.1 M539.3,165.6l-31.9,4.9l23.1,13.2L539.3,165.6L539.3,165.6 L539.3,165.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M526.9,2.3v179.2c0,8.1-4.4,15.7-11.4,19.7l-35.9,20.4l178,102.8l35.9-20.4c7.1-4,11.4-11.5,11.4-19.7V105 L526.9,2.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 527,
    y1: 2.3,
    x2: 706.7,
    y2: 106.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M706.7,108.3c-0.4,0-0.8-0.1-1.1-0.3L525.9,4.2c-1.1-0.6-1.5-2-0.8-3.1c0.6-1.1,2-1.5,3.1-0.8l179.7,103.8 c1.1,0.6,1.5,2,0.8,3.1C708.2,107.9,707.5,108.3,706.7,108.3L706.7,108.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "593.2,231.8 613.4,220.1 613.4,196.7 593.2,208.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "545.8,181.1 593.2,208.4 613.4,196.7 599.9,149.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "545.8,243.5 593.2,231.8 593.2,208.4 545.8,181.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M613.3,401.7c0.1,0,0.2,0,0.3,0c1.3-0.2,2.3-1.4,2.1-2.7l-9.8-74c-0.2-1.3-1.4-2.3-2.7-2.1 c-1.3,0.2-2.3,1.4-2.1,2.7l9.8,74C611,400.8,612.1,401.7,613.3,401.7L613.3,401.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M636.2,351.7c0.7,0,1.5-0.3,2-1c0.8-1.1,0.6-2.6-0.5-3.4l-32.7-24c-1.1-0.8-2.6-0.6-3.4,0.5 s-0.6,2.6,0.5,3.4l32.7,24C635.2,351.5,635.7,351.7,636.2,351.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M550.5,365.4c0.5,0,1-0.1,1.4-0.5l54-38.5V215.1c0-1.3-1.1-2.4-2.4-2.4s-2.4,1.1-2.4,2.4v109l-52,37 c-1.1,0.8-1.3,2.3-0.6,3.4C548.9,365.1,549.7,365.4,550.5,365.4L550.5,365.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M611.8,343.7l-5.6,11.5l-14.7-8.4L611.8,343.7 M620.2,337.5l-43.2,6.6l31.4,17.9L620.2,337.5L620.2,337.5 L620.2,337.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "280.4,178.8 260.2,167.1 260.2,143.7 280.4,155.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "327.8,128.1 280.4,155.4 260.2,143.7 273.7,96.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "327.8,190.5 280.4,178.8 280.4,155.4 327.8,128.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M264.2,325.8c-0.1,0-0.2,0-0.3,0c-1.3-0.2-2.3-1.4-2.1-2.7l5.9-51.1c0.2-1.3,1.4-2.3,2.7-2.1 c1.3,0.2,2.3,1.4,2.1,2.7l-5.9,51.1C266.5,324.9,265.4,325.8,264.2,325.8L264.2,325.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M237.4,298.7c-0.7,0-1.5-0.3-2-1c-0.8-1.1-0.6-2.6,0.5-3.4l32.7-24c1.1-0.8,2.6-0.6,3.4,0.5s0.6,2.6-0.5,3.4 l-32.7,24C238.4,298.5,237.9,298.7,237.4,298.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M323.1,312.4c-0.5,0-1-0.1-1.4-0.5l-54-38.5V162.1c0-1.3,1.1-2.4,2.4-2.4s2.4,1.1,2.4,2.4v109l52,37 c1.1,0.8,1.3,2.3,0.6,3.4C324.6,312.1,323.9,312.4,323.1,312.4L323.1,312.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M261.8,290.7l20.3,3.1l-14.7,8.4L261.8,290.7 M253.4,284.5l11.8,24.5l31.4-17.9L253.4,284.5L253.4,284.5 L253.4,284.5z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "0,177.4 367,389.3 393.3,374.1 26.3,162.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "550.7,495.3 865.1,313.7 865.2,283.5 550.7,465.2  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M403.4,384.6c-0.1,0-0.2,0-0.3,0c-1.1-0.1-1.9-1.2-1.7-2.3l8.1-146.9c0.1-1.1,1.2-1.9,2.3-1.7 c1.1,0.1,1.9,1.2,1.7,2.3l-8.1,146.8C405.3,383.8,404.4,384.6,403.4,384.6L403.4,384.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M384.4,343.1c-0.6,0-1.2-0.3-1.6-0.8c-0.7-0.9-0.5-2.2,0.4-2.8l27.1-105.4c0.9-0.7,2.2-0.5,2.8,0.4 s0.5,2.2-0.4,2.8l-27.1,105.4C385.2,343,384.8,343.1,384.4,343.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M455.5,354.5c-0.4,0-0.8-0.1-1.2-0.4l-44.8-117.4v-6.8c0-1.1,0.9-2,2-2s2,0.9,2,2v4.7l43.1,116.2 c0.9,0.6,1.1,1.9,0.5,2.8C456.7,354.2,456.1,354.5,455.5,354.5L455.5,354.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M404.6,289.4l16.8,2.6l-12.2,7L404.6,289.4 M397.7,284.2l9.8,20.3l26-14.8L397.7,284.2L397.7,284.2 L397.7,284.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M440.8,193.1l4.1-2.1c1-0.5,2.3-0.5,3.3,0.1l13.1,7.8c1,0.6,1.6,1.7,1.6,2.9v9.5c0,1.1-0.5,2.1-1.5,2.8 l-3.8,2.6l-14.3-16.3L440.8,193.1L440.8,193.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M456.5,216.2l-15.7-11.8c-0.4-0.3-0.6-0.7-0.6-1.1v-9.1c0-1,1.1-1.6,2-1l15.7,10.2 c0.4,0.3,0.6,0.7,0.6,1.2v10.8C458.5,216.3,457.3,216.9,456.5,216.2L456.5,216.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M453.5,207.5c0-3.8-2.3-8.2-5.1-9.8c-1.2-0.7-2.3-0.8-3.1-0.4l0,0c-0.2,0.1-0.3,0.2-0.5,0.3l-15,8.6 l6.7,14.2l15.1-8.7c0.1-0.1,0.2-0.1,0.3-0.2h0l0,0C452.8,210.9,453.5,209.5,453.5,207.5L453.5,207.5z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9202 -0.3916 0.3916 0.9202 -48.943 186.6194)",
    className: "st8",
    cx: 433.1,
    cy: 213.3,
    rx: 4.5,
    ry: 7.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "399.1,251.1 388.9,245.4 388.9,218.6 399.1,224.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "439.8,201.3 429.6,195.6 388.9,218.9 399.1,224.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "399.1,251.1 439.8,228 439.8,201.1 399.1,224.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "402.7,243.1 391.1,237.2 391.1,214.9 402.7,220.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "402.7,243.1 396.9,246.5 396.9,227.2 399.4,222.5 402.7,220.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "391.1,237.2 385.3,240.6 385.3,221.2 387.8,216.5 391.1,214.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "396.9,227.2 385.3,221.2 387.8,216.5 399.4,222.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "396.9,246.5 385.3,240.6 385.3,221.2 396.9,227.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "402.7,220.8 391.1,214.9 387.8,216.5 399.4,222.5  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "432.2,201.2 428.3,199.1 428.3,196.7 432.5,196.1 433.4,197.1  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "396.9,216 402,205.4 406.7,207.6 401.8,218.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "418,195.3 402,205.4 406.7,207.6 422.9,197.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "418,195.3 427.7,192.5 432.5,194.7 422.9,197.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M432.2,201.2l0.2-2.4c0-0.5-0.4-0.8-0.9-0.6l-10.6,3.3c-0.1,0-0.1,0-0.2,0.1l-12.2,8.1 c-0.2,0.1-0.3,0.3-0.3,0.5l-0.5,5l-6.1,3.5l4.9-11l16.3-9.8l9.5-3.1l2.5,1.5l0.2,3.4L432.2,201.2L432.2,201.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9254 -0.3791 0.3791 0.9254 -40.4031 185.7296)",
    className: "st20",
    cx: 451.5,
    cy: 195.5,
    rx: 2.6,
    ry: 2.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9254 -0.3791 0.3791 0.9254 -42.5799 183.1539)",
    className: "st20",
    cx: 443.9,
    cy: 199.7,
    rx: 2.6,
    ry: 2.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "445.1,202.1 442.6,197.4 450.2,193.1 452.8,197.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9252 -0.3796 0.3796 0.9252 -42.8358 183.2362)",
    className: "st21",
    cx: 443.3,
    cy: 200.3,
    rx: 3.4,
    ry: 3.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9252 -0.3796 0.3796 0.9252 -45.7375 179.8044)",
    className: "st21",
    cx: 433.1,
    cy: 205.9,
    rx: 3.4,
    ry: 3.6
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "434.8,209 431.4,202.8 441.6,197.1 445,203.4  "
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M418.7,227.4l-11.7,6.2c-0.6,0.3-1.3-0.1-1.3-0.8v-9c0-0.3,0.2-0.6,0.5-0.8l11.7-6.2 c0.6-0.3,1.3,0.1,1.3,0.8v9C419.2,226.9,419,227.2,418.7,227.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M393.4,234.7l-6.3-3.3c-0.3-0.2-0.5-0.5-0.5-0.8v-5c0-0.7,0.7-1.1,1.4-0.8l6.3,3.3c0.3,0.2,0.5,0.5,0.5,0.8 v5C394.8,234.5,394,235,393.4,234.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "786.5,177.4 773.4,169.8 485,336.3 485,487.7 498.1,495.2 786.5,328.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "498.2,495.2 786.5,328.7 773.4,321.2 485.1,487.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "498.2,343.9 786.5,177.4 773.4,169.8 485.1,336.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "786.5,328.7 786.5,177.4 773.4,169.8 773.4,321.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "498.1,495.2 498.1,343.9 485,336.3 485,487.7  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "550.7,313.5 865.1,131.9 865.2,101.7 550.7,283.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "367,389.3 550.7,283.4 550.7,495.2 367,601.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "865.2,101.7 865.2,313.4 786.6,358.8 786.6,147  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "838.9,86.6 340.8,374 367,389.2 865.2,101.7  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudio);
export default __webpack_public_path__ + "static/media/studio.af782c2758f2f917e6d31c05f90e797e.svg";
export { ForwardRef as ReactComponent };